<em
  class="icon-color {{ icon }} badge-anchor"
  matBadgeColor="warn"
  matBadgeSize="small"
  [matBadgeHidden]="hideBadges()"
  [matBadge]="items"></em>
